let map: google.maps.Map
export async function initMap() {
    const mapEl = document.querySelector('[data-map-holder]') as HTMLElement
    if (!mapEl) return

    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

    const mapCenter = {lat: 49.83577267930496, lng: 18.155219887382238},
        themeRoot = mapEl.dataset.themeUri,
        compactView = window.innerWidth < 640

    map = new Map(mapEl, {
        center: mapCenter,
        zoom: compactView ? 14 : 15,
        gestureHandling: compactView ? "auto" : "none",
        zoomControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        styles: [
            {
                "featureType": "all",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                    {
                        "weight": "0.5"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "lightness": "-50"
                    },
                    {
                        "saturation": "-50"
                    }
                ]
            },
            {
                "featureType": "administrative.neighborhood",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "hue": "#009aff"
                    },
                    {
                        "saturation": "25"
                    },
                    {
                        "lightness": "0"
                    },
                    {
                        "visibility": "simplified"
                    },
                    {
                        "gamma": "1"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "saturation": "0"
                    },
                    {
                        "lightness": "100"
                    },
                    {
                        "gamma": "2.31"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "lightness": "20"
                    },
                    {
                        "gamma": "1"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": "-100"
                    },
                    {
                        "lightness": "-100"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "lightness": "0"
                    },
                    {
                        "saturation": "45"
                    },
                    {
                        "gamma": "4.24"
                    },
                    {
                        "visibility": "simplified"
                    },
                    {
                        "hue": "#00ff90"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "saturation": "-100"
                    },
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "color": "#666666"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "saturation": "-25"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "transit.station.airport",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "50"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "lightness": "50"
                    },
                    {
                        "gamma": ".75"
                    },
                    {
                        "saturation": "-50"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            }
        ]
    });

    const marker = new google.maps.Marker({
        position: mapCenter,
        icon: `${themeRoot}/resources/images/map-logo.svg`,
        map: map
    });

    const pointsDefinition = [{
        title: "Fakultní nemocnice Ostrava",
        category: "hospital",
        position: { lat: 49.827943942558306, lng: 18.161507701684485 }
    }, {
        title: "Vysoká škola báňská - Technická univerzita Ostrava",
        category: "school",
        position: { lat: 49.83167059650012, lng: 18.163804364017498 }
    }, {
        title: "Globus Hypermarket",
        category: "service",
        position: { lat: 49.84817788177619, lng: 18.147837766442656 }
    }, {
        title: "Nákupní centrum Géčko Ostrava",
        category: "service",
        position: { lat: 49.84907142773282, lng: 18.14578442533003 }
    }, {
        title: "CØKAFE Poruba",
        category: "service",
        position: { lat: 49.830876817769926, lng: 18.165245665785154 }
    }, {
        title: "Planetárium Ostrava",
        category: "activity",
        position: { lat: 49.83737487438155, lng: 18.144926122291388 }
    }];

    const points = {
        hospital: [],
        school: [],
        service: [],
        activity: []
    }

    pointsDefinition.forEach(pointData => {
        const interestPoint = document.createElement('button')
            interestPoint.className = 'InterestPoint'

        points[pointData.category].push(new google.maps.Marker({
            map,
            position: pointData.position,
            title: pointData.title,
            icon: `${themeRoot}/resources/images/map-point.png`,
            optimized: true,
        }));
    })

    document.querySelectorAll<HTMLButtonElement>('[data-category]')
        .forEach(toggle => toggle.addEventListener('click', () => {
            const category = toggle.dataset.category

            document.querySelectorAll<HTMLButtonElement>(`[data-category]:not([data-category="${category}"])`)
                .forEach(button => button.classList.remove('is-active'))

            toggle.classList.toggle('is-active')
            if (toggle.classList.contains('is-active')) {
                Object.keys(points).forEach(group => points[group].forEach(point => point.setMap(null)))
                points[category].forEach(point => point.setMap(map))
            } else {
                Object.keys(points).forEach(group => points[group].forEach(point => point.setMap(map)))
            }
        }))

    map.addListener("tilesloaded", () => mapEl.classList.remove('is-loading'))
    //map.addListener("click", (mapsMouseEvent) => console.log(mapsMouseEvent.latLng.toJSON()));
}